import React, { Component } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './style.css';

class Rsvp extends Component {
    state = {
        name: '',
        mobile: '',
        rsvp: '',
        events: '',
        notes: '',
        error: {},
        isSubmitting: false
    };

    // Success toast
    showSuccessToast = () => {
        toast.success('RSVP submitted successfully!', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    // Error toast
    showErrorToast = (message) => {
        toast.error(message || 'Failed to submit RSVP. Please try again.', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    changeHandler = (e) => {
        const error = this.state.error;
        error[e.target.name] = '';

        this.setState({
            [e.target.name]: e.target.value,
            error
        });
    };

    subimtHandler = async (e) => {
        e.preventDefault();
    
        const { name, mobile, rsvp, events, notes } = this.state;
        const error = {};
    
        // Validation
        if (name === '') error.name = "Please enter your name";
        if (mobile === '') error.mobile = "Please enter your mobile";
        if (rsvp === '') error.rsvp = "Select your number of rsvp";
        if (events === '') error.events = "Select your attendance";
        // if (notes === '') error.notes = "Please enter your note";
    
        if (Object.keys(error).length > 0) {
            this.setState({ error });
            return;
        }
    
        this.setState({ isSubmitting: true, error: {} });

        const DEPLOY_URL = 'https://script.google.com/macros/s/AKfycbyjizhQjvbOxKv7esRlQI3lNLdaHnOhmaDc5obVtHd7RivGLXOTel7Jd3rAOVy--_-ncA/exec';

        try {

            // Create form data
            const formData = new URLSearchParams();
            formData.append('name', name);
            formData.append('mobile', mobile);
            formData.append('rsvp', rsvp);
            formData.append('events', events);
            formData.append('message', notes || "-");

            const response = await axios({
                method: 'POST',
                url: DEPLOY_URL,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: formData.toString()
            });
    
            console.log('Submission successful:', response.data);
            this.showSuccessToast();
    
            // Reset form
            this.setState({
                name: '',
                mobile: '',
                rsvp: '',
                events: '',
                notes: '',
                error: {},
                isSubmitting: false
            });
    
        } catch (error) {
            console.error('Error submitting form:', error);
            this.showErrorToast(error.message);
            this.setState({ isSubmitting: false });
        }
    };

    render() {
        const { name, mobile, rsvp, events, notes, error, isSubmitting } = this.state;

        return (
            <div id="rsvp" className="rsvp-area go-rsvp-area section-padding">
                <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={true}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="colored"
                    style={{
                        marginTop: '5em',
                        zIndex: 999999,
                        position: 'fixed',
                        width: 'auto'
                    }}
                    toastStyle={{
                        zIndex: 999999,
                        position: 'relative',
                        maxWidth: '90%',
                        margin: '0 auto'
                    }}
                />


                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2 col-md-10 offset-md-1">
                            <div className="rsvp-wrap">
                                <div className="col-12">
                                    <div className="section-title section-title4 text-center">
                                        <h2>Be Our Guest</h2>
                                        <p>Please reserve before January 15th, 2025.</p>
                                    </div>
                                </div>
                                <form onSubmit={this.subimtHandler}>
                                    <div className="contact-form form-style">
                                        <div className="row">
                                            <div className="col-12 col-sm-6">
                                                <input
                                                    type="text"
                                                    value={name}
                                                    onChange={this.changeHandler}
                                                    placeholder="Your Name*"
                                                    id="fname"
                                                    name="name"
                                                    disabled={isSubmitting}
                                                />
                                                <p>{error.name ? error.name : ''}</p>
                                            </div>
                                            <div className="col-12 col-sm-6">
                                                <input
                                                    type="number"
                                                    placeholder="Your Mobile No.*"
                                                    onChange={this.changeHandler}
                                                    value={mobile}
                                                    id="mobile"
                                                    name="mobile"
                                                    disabled={isSubmitting}
                                                    pattern="[+0-9]+" // Allow plus sign and numbers
                                                />

                                                <p>{error.mobile ? error.mobile : ''}</p>
                                            </div>
                                            <div className="col col-sm-6 col-12">
                                                <select
                                                    className="form-control"
                                                    onChange={this.changeHandler}
                                                    value={rsvp}
                                                    name="rsvp"
                                                    disabled={isSubmitting}
                                                >
                                                    <option disabled value="">
                                                        Number of rsvp*
                                                    </option>
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                </select>
                                                <p>{error.rsvp ? error.rsvp : ''}</p>
                                            </div>
                                            <div className="col col-sm-6 col-12">
                                                <select
                                                    className="form-control"
                                                    onChange={this.changeHandler}
                                                    value={events}
                                                    name="events"
                                                    disabled={isSubmitting}
                                                >
                                                    <option disabled value="">
                                                        Will you attend?*
                                                    </option>
                                                    <option value="yes">Yes, I will attend</option>
                                                    <option value="no">No, I cannot attend</option>
                                                </select>
                                                <p>{error.events ? error.events : ''}</p>
                                            </div>
                                            <div className="col-12 col-sm-12">
                                                <textarea
                                                    className="contact-textarea"
                                                    value={notes}
                                                    onChange={this.changeHandler}
                                                    placeholder="Message"
                                                    name="notes"
                                                    disabled={isSubmitting}
                                                ></textarea>
                                                {/* <p>{error.notes ? error.notes : ''}</p> */}
                                            </div>
                                        </div>
                                        <div className="col-12 text-center">
                                            <button 
                                                id="submit" 
                                                type="submit" 
                                                className="submit"
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? 'Sending...' : 'Submit'}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Rsvp;
